exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".luck2022__inn[data-v-41fe3b25]{padding:24px 24px 0;max-width:540px;margin:0 auto}.luck2022__list[data-v-41fe3b25]{margin-bottom:80px}.luck2022__counselor[data-v-41fe3b25]{margin-bottom:56px}.luck2022__sns[data-v-41fe3b25],.luck2022__subsc[data-v-41fe3b25]{margin-bottom:80px}.luck2022__svg[data-v-41fe3b25]{display:block;margin:0 auto 40px}.luck2022__svg circle[data-v-41fe3b25]{fill:#dcdfe2}.otherCounselor[data-v-41fe3b25]{background:#f5f7fa;padding:40px 24px 44px}.otherCounselor__inn[data-v-41fe3b25]{max-width:440px;margin:0 auto}.otherCounselor__title[data-v-41fe3b25]{text-align:center;font-weight:700;font-size:22px;line-height:24px;letter-spacing:1px;color:#32373f;margin:0 0 32px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-41fe3b25","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/YearLuck/y2022/yearluck2022Result.vue
// module id = UpXK
// module chunks = 0